import { useEffect, useState } from 'react';

import BoundariesGrid from 'components/BoundariesGrid';
import Page from 'components/Page';

import useBoundaries from 'hooks/useBoundaries';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BoundariesPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { boundaries = [], fetch } = useBoundaries();

    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        (async () => {
            const { done } = await fetch().next();

            setHasMore(!done);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = async () => await fetch().next();

    return (
        <Page className={styles.boundariesPage} testId={testId}>
            <BoundariesGrid onNext={hasMore ? handleNext : undefined} rows={boundaries} />
        </Page>
    );
};

export default BoundariesPage;
